import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DynamicFeatureFlagService, getAdminHomeUrl, UserService } from 'shared/services';

@Injectable()
export class NoAuthGuard {
    constructor(
        private userService: UserService,
        private router: Router,
        private dynamicFeatureFlagService: DynamicFeatureFlagService
    ) {}

    canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> {
        if (!this.userService.isLoggedIn()) {
            return true;
        }

        if (this.userService.isAdmin()) {
            return getAdminHomeUrl(this.dynamicFeatureFlagService).pipe(map((url) => this.router.parseUrl(url)));
        }

        return this.router.createUrlTree(['news']);
    }
}
